import Accordion from '../components/accordion'
import BrowserNotice from '../components/browser-notice'
import CloudHoverText from '../components/cloud-hover-text'
import MainNav from '../components/main-nav'
import Search from './search'
import ToTop from '../components/to-top-button'
import ToggleLanguage from '../components/toggle'
import ScrollToBottom from '../components/scroll-to-bottom'

export default function SiteWide() {
  const init = () => {
    MainNav().init()
    Accordion().init()
    ToTop().init()
    Search()
    BrowserNotice().init()
    CloudHoverText().init()
    ToggleLanguage().init()
    ScrollToBottom().init()
  }

  return {
    init: init,
  }
}
